<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">Seemless Game Management</a>
    <div class="collapse navbar-collapse gap-2 ms-auto">
      <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="selected_category" (change)="onCategoryChange()">
        <option value="">All Categories</option>
        <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.title }}</option>
      </select>
      <a class="btn btn-sm btn-outline-primary" [routerLink]="['/lo', company_uuid, 'api-game-setting', 'form']">&#43; Add Game</a>
    </div>
  </div>
</nav>
<hr/>

<div class="row">
  <div class="col-12">
    <div class="table-container">
      <table class="table table-striped mb-0">
        <thead class="bg-dark text-light">
          <tr style="position: sticky; top: 0">
            <th>No</th>
            <th>Title</th>
            <th>Category</th>
            <th>Event-Only</th>
            <th>Status</th>
            <th>Sort</th>
            <th>View</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody *ngIf="!is_loading && games.length > 0">
          <tr *ngFor="let game of games; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ game.title }}</td>
            <td>{{ game.category_title || '-' }}</td>
            <td>
              <span *ngIf="game.event_only == 1 || game.event_only === true" class="badge bg-warning text-dark">Event-Only</span>
              <span *ngIf="!game.event_only || game.event_only == 0">-</span>
            </td>
            <td>
              <span *ngIf="game.status">Active</span>
              <span *ngIf="!game.status">Disabled</span>
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" style="width: 80px;"
                [(ngModel)]="game.sort" (blur)="saveSort(game)" />
            </td>
            <td><a [routerLink]="['/lo', company_uuid, 'api-game-setting', 'form', game.uuid]">View</a></td>
            <td><a href="javascript:void(0)" (click)="deleteGame(game)">Delete</a></td>
          </tr>
        </tbody>
        <tbody *ngIf="!is_loading && games.length === 0">
          <tr><td colspan="8" class="p-3">No Data Available</td></tr>
        </tbody>
        <tbody *ngIf="is_loading">
          <tr><td colspan="8" class="d-flex flex-row align-items-center ps-1">
            <div class="loader"></div> <span>Loading</span>
          </td></tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
